module.exports = __webpack_public_path__ + "img/female-placeholder.b4220107.webp";